import instance from './instance'
import accountModule from './account'

export default {
    account: accountModule(instance),
}